import { FooterData, OpCoData } from '../../models';

import { UseContentSelector } from './UseContentSelector';
import { MarketContent } from './MarketContent';

export const FooterContent: UseContentSelector<Array<OpCoData>, FooterData> = {
  useResultSelector: MarketContent.useResultSelector,
  useDataSelector: (data) => MarketContent.useDataSelector(data).footer,
};
